import { useEffect, useState } from "react"
import maleSVG from "../../assets/images/male.svg"
import { TrendingCard } from "../../components/trendingCard/trendingCard.component"
import { getTrendIdeas } from "../../services/ideas.service"
import millify from "millify"

export const TrendingCardList = ({ votesCount, commentCount }) => {
    const [trendIdeas, setTrendIdeas] = useState([])
    const getTrendIdeasData = async () => {
        const { status, data } = await getTrendIdeas()
        if (status == 200) {
            setTrendIdeas(data);
        }
    };
    useEffect(() => {
        getTrendIdeasData()

    }, [])

    return (
        <div className="card card-employee-task">
            <div className="card-header">
                <h2 className="text-uppercase mb-0">
                    <span className="star-orange">trending</span> ideas
                </h2>
            </div>
            <div className="card-body trending-ideas pb-1">
                {
                    trendIdeas.map((idea, index) => {
                        return <TrendingCard key={index} name={idea.EMP_NAME} ideaId={idea.IDEA_ID} image={maleSVG} votesCount={millify(idea.hearts + idea.likes)} commentCount={millify(idea.comments)} />
                    })
                }

            </div>
        </div>

    )
} 